<template>
  <v-dialog
    max-width="750"
    persistent
    v-model="showDialog">
    <v-card class="pa-5">
      <v-card-title>
        <h3>Please enter a super-secure secret string</h3>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="secret"
          type="password"
          label="Secret">
        </v-text-field>
        <v-text-field
          v-model="confirmSecret"
          type="password"
          label="Confirm Secret">
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="cancelDialog">
          Cancel
        </v-btn>
        <v-btn
          color="red darken-1"
          text
          @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['showDialog'],
  data () {
    return {
      secret: null,
      confirmSecret: null
    }
  },
  methods: {
    cancelDialog () {
      this.$emit('cancelDialog')
    },
    save () {
      if (this.secret && this.secret === this.confirmSecret) {
        this.$emit('saveSecret', this.secret)
      }
    }
  }

}
</script>